import { useState } from "react";

const ProductImage = ({src ,product}) => {
  const [loaded, setLoaded] =useState(false);
  const [error, setError] =useState(false);
  return (
    <figure className="bg-gradient-product w-100 product-image">
              <div className={`m-auto img-middle image-wrapper ${loaded ? "loaded" : ""}    h-100`}>
                {product.images && (
                  <img
                    src={error ? "/placeholder.jpg" : src}
                    className="img-fluid h-100"
                    alt=""
                    onLoad={()=>setLoaded(true)}
                    onError={()=>setError(true)}
                  />
                )}
              </div>      
            </figure>
  )
}

export default ProductImage